export const featuredPortfolio=[
    {
        id:1,
        title:"Social media management",
        img:"assets/socialmediaa.jpeg"
    },
    {
        id:2,
        title:"Rampa UI Design",
        img:"assets/designa.jpg"
    },
    {
        id:3,
        title:"E-commerce Web Design",
        img:"assets/ecommercea.png"
    },
    {
        id:4,
        title:"Relax Mobile App",
        img:"assets/mobilea.jpg"
    },
    {
        id:5,
        title:"UI/UX Designer",
        img:"assets/weba.jpg"
    },
    {
        id:6,
        title:"Banking App",
        img:"assets/bankb.png"
    }
]

export const webPortfolio=[
    {
        id:1,
        title:"Social Media App",
        img:"assets/socialmediac.jpg"
    },
    {
        id:2,
        title:"Rampa UI Design",
        img:"assets/designc.jpg"
    },
    {
        id:3,
        title:"Web Design",
        img:"assets/webd.jpeg"
    },
    {
        id:4,
        title:"Mobile Apps",
        img:"assets/mobilec.png"
    },
    {
        id:5,
        title:"Hero Web Design",
        img:"assets/webe.jpg"
    },
    {
        id:6,
        title:"Banking App",
        img:"assets/bankd.jpg"
    }
]

export const mobilePortfolio=[
    {
        id:1,
        title:"Social Media App",
        img:"assets/socialmedia.jpeg"
    },
    {
        id:2,
        title:"Rampa UI Design",
        img:"assets/design.jpg"
    },
    {
        id:3,
        title:"E-commerce App",
        img:"assets/ecommerce.png"
    },
    {
        id:4,
        title:"Relax Mobile App",
        img:"assets/mobile.jpg"
    },
    {
        id:5,
        title:"Hero Web App",
        img:"assets/web.jpg"
    },
    {
        id:6,
        title:"Banking App",
        img:"assets/banka.jpg"
    }
]

export const designPortfolio=[
    {
        id:1,
        title:"Social Media Design",
        img:"assets/socialmediaa.jpeg"
    },
    {
        id:2,
        title:"Rampa UI Design",
        img:"assets/designa.jpg"
    },
    {
        id:3,
        title:"E-commerce Web Design",
        img:"assets/ecommercea.png"
    },
    {
        id:4,
        title:"Relax Mobile Design",
        img:"assets/mobilea.jpg"
    },
    {
        id:5,
        title:"Hero Web Design",
        img:"assets/weba.jpg"
    },
    {
        id:6,
        title:"Banking Design",
        img:"assets/bankb.png"
    }
]

export const contentPortfolio=[
    {
        id:1,
        title:"Social Media Content",
        img:"assets/socialmediab.jpeg"
    },
    {
        id:2,
        title:"Rampa UI Content",
        img:"assets/designb.jpg"
    },
    {
        id:3,
        title:"E-commerce Content",
        img:"assets/ecommerceb.jpeg"
    },
    {
        id:4,
        title:"Mobile Content",
        img:"assets/mobileb.jpg"
    },
    {
        id:5,
        title:" Web Design Content",
        img:"assets/webc.png"
    },
    {
        id:6,
        title:"Banking Content",
        img:"assets/bankc.jpg"
    }
]
